import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'every',
    standalone: true,
    pure: true
})
export class EveryPipe implements PipeTransform {
  transform(items: any[], property: string, value: any = true): boolean {
    if (!items?.length) {
      return true;
    }
    return items.every(item => item[property] === value);
  }
}
